import { EncoderState } from 'src/contracts/encoderState';
import { useGrouperStore } from 'stores/grouper-store';
import { useLayoutStore } from 'stores/layout-store';
import {useSearchStore} from 'stores/search-store';
import {useTrucodeReferenceStore} from 'stores/references-store';

export function getEncoderState(): EncoderState {
  return {
    grouperState: useGrouperStore().getGrouperState(),
    layoutState: useLayoutStore().getLayoutState(),
    searchState: useSearchStore().getSearchState(),
    referencesState: useTrucodeReferenceStore().getReferencesState(),
  }
}

export function setEncoderState(state?: EncoderState): void {

  if (!state) {
    return;
  }

  useGrouperStore().setGrouperState(state.grouperState);
  useLayoutStore().setLayoutState(state.layoutState);
  useSearchStore().setSearchState(state.searchState);
  useTrucodeReferenceStore().setReferencesState(state.referencesState);
}
